function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { FunctionalLoader } from 'seagull';
import { useStoreActions } from "../contexts";
import AgreementStudioTemplates from "./AgreementStudio/AgreementStudioTemplates";
import { makeSentryIgnoredError } from "./ErrorBoundaryPage";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ProposalTemplateLoader(props) {
  const {
    api
  } = useStoreActions();
  const {
    templateId
  } = props.match.params;
  const [template, setTemplate] = useState({
    data: undefined,
    error: null
  });
  useEffect(() => {
    setTemplate({
      data: undefined,
      error: undefined
    });
    api.proposalTemplates.get(templateId).then(res => setTemplate({
      data: res,
      error: undefined
    }), err => setTemplate({
      data: undefined,
      error: err
    }));
  }, [templateId]);
  if (template.error) {
    throw makeSentryIgnoredError('Failed to fetch template');
  } else if (!template.data) {
    return /*#__PURE__*/_jsx(FunctionalLoader, {
      name: "ProposalTemplateLoader",
      show: true
    });
  } else {
    return /*#__PURE__*/_jsx(AgreementStudioTemplates, _objectSpread(_objectSpread({}, props), {}, {
      template: template.data
    }));
  }
}